<template>
  <b-modal
    id="update-hold-service-system-standalone-modal"
    cancel-variant="outline-secondary"
    :ok-title="$t('button.confirm')"
    :cancel-title="$t('button.close')"
    centered
    no-close-on-backdrop
    :title="$t('breadcrumb.updateServiceSystem')"
    :loading="loading"
    @ok="handleOk"
    @cancel="handleClose"
    @close="handleClose"
  >
    <template #modal-footer>
      <b-button
        variant="outline-secondary"
        class="btn"
        @click="handleClose"
      >
        {{ $t('button.close') }}
      </b-button>
      <n-button-loading
        :loading="loading"
        class="btn"
        variant="primary"
        @submit="handleOk"
      >
        {{ $t('button.confirm') }}
      </n-button-loading>
    </template>
    <validation-observer
      ref="updateHoldServiceSystemStandaloneForm"
      #default="{ invalid }"
    >
      <n-form-confirmation
        ref="formConfirmation"
        key="assignOperatorForm"
        :message="
          $t('general.serviceUpdateStatusTo', {
            status: $t(`status.hold`)
          })+
            ' ' +
            (data.noOfminuteHold
              ? $tc('general.forMinute', data.noOfminuteHold, { minute: data.noOfminuteHold })
              : '')
        "
        :confirm-button-text="`button.confirm`"
        :cancel-button-text="`button.no`"
        :form="$refs.assignOperatorForm"
        :disabled="invalid"
        @submit="submit"
      >
        <n-input
          v-model="data"
          :fields="formInput"
        />
      </n-form-confirmation>
    </validation-observer>
  </b-modal>
</template>

<script>
import { BModal, BButton } from 'bootstrap-vue'
import Repository from '@/repositories/RepositoryFactory'
import NInput from '@/components/NInput.vue'
import useJwt from '@/auth/jwt/useJwt'
import NFormConfirmation from '@/components/NFormConfirmation.vue'
import NButtonLoading from '@/components/NButtonLoading.vue'
import FormInput from './updateServiceSystemFormInput'

const ServiceSystemRepository = Repository.get('serviceSystem')

export default {
  components: {
    BModal,
    NInput,
    NFormConfirmation,
    BButton,
    NButtonLoading,
  },
  props: {
    activeRoom: {
      type: Object,
      required: false,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      loading: false,
      data: {
        noOfminuteHold: null,
        serviceSystemId: null,
        remark: '',
      },
      key: 1,
    }
  },
  computed: {
    userData() {
      return this.$store.state.profile.email || this.$store.state.profile.phone  
        ? this.$store.state.profile
        : JSON.parse(
          localStorage.getItem(useJwt.jwtConfig.storageUserDataKeyName),
        )
    },
  },
  methods: {
    handleClose() {
      this.data.noOfminuteHold = ''
      this.hide()
    },
    show(id) {
      this.key += 1
      this.data.serviceSystemId = id
      this.$bvModal.show('update-hold-service-system-standalone-modal')
    },
    hide() {
      this.$bvModal.hide('update-hold-service-system-standalone-modal')
    },
    handleOk(bvModal) {
      if (bvModal) bvModal.preventDefault()
      if (this.loading) return

      this.$refs.updateHoldServiceSystemStandaloneForm.validate().then(success => {
        if (success) {
          this.$refs.formConfirmation.confirm()
        }
      })
    },
    async submit() {
      this.loading = true

      ServiceSystemRepository.updateStatus(
        {
          status: 'hold',
          ...(this.data.noOfminuteHold && { noOfminuteHold: this.data.noOfminuteHold }),
          ...(this.data.remark && { remark: this.data.remark }),
        },
        this.data.serviceSystemId,
      )
        .then(response => {
          this.data.noOfminuteHold = null
          this.hide()
          this.$emit('success', response)
        })
        .catch(error => {
          if (error.response?.status === 422) {
            this.$refs.assignOperatorForm.setErrors(
                error.response?.data?.validate,
            )
          }
        })
        .then(() => {
          this.loading = false
        })
    },
  },
  setup() {
    const formInput = [...FormInput]

    return {
      formInput,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
